
import { CARRIER } from '../util/constants'

export default {
  data() {
    return {
      timer: null,
      time: 0,
      CARRIER
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch:{
    time(){
      if(this.time === 0) {
      clearInterval(this.timer);
      }
    }
  },
  methods: {
    startTimer(){
      this.time = 10;
      this.timer = setInterval(this.decreaseTime, 1000);
    },
    decreaseTime() {
      this.time -= 1;
    },
    resendEmail() {
      this.startTimer()
      this.$store
        .dispatch('user/resendEmail', this.user.currentUser.userName)
        .then(() => {
          this.$toast.success('Email Successfully Sent').goAway(3000);
        })
        .catch(() => {
          this.$toast.error('Failed to resend Email- Contact support@utransport.com.au').goAway(5000);
        });
    },
  },
};
